/**
 * This file contains interface utilities for user roles
 * for the application. Provides functionality for
 * Role-based access control for the application.
 */

/**
 * Returns {@code true} if the given {@param userType}
 * matches the given {@param authUser}'s role
 */
export const isUserRole = (userType, authUser) => {
    return isNotGuestUser(authUser)
        && authUser.role
        && authUser.role === userType;
};

/**
 * Returns {@code true} if the given
 * {@param authUser} is not null (guest)
 */
export const isNotGuestUser = (authUser) => {
    return !!authUser;
};



// WEBPACK FOOTER //
// ./src/utils/userRoles.js